/**
 * Regional Analysis Translations Module (Japanese)
 * 
 * Contains: Regional Analysis, Regional Distribution, Regional FII Analysis, Regional Maps
 * 
 * @module regional
 * @language ja
 */

export const regional = {
  regional: {
    title: "地域分析",
    subtitle: "地理的地域別のアクティブ会員",
    asiaPacific: "アジアと太平洋",
    europe: "ヨーロッパ",
    americas: "アメリカ",
    africaMiddleEast: "アフリカ・中東"
  },
  regionalAnalysisPage: {
    pageSubtitle: "4つのJCI地域にわたる1,000+プロジェクト • 148,122人の会員 • 4,641のローカル組織"
  },
  regionalDistribution: {
    title: "地域分布",
    subtitle: "2024-2025年の4つのJCI地域にわたる1,000+プロジェクト",
    totalMembers: "総会員数",
    localOrganizations: "ローカル組織",
    countries: "国",
    annualProjects: "年間プロジェクト",
    projectDistributionTitle: "地域別プロジェクト分布（2024-2025）",
    projects: "プロジェクト",
    risePillarTitle: "JCI RISEピラー分布",
    total: "合計",
    mentalHealth: "メンタルヘルス",
    mentalHealthBeneficiaries: "590万人以上の受益者にリーチ",
    workforceResilience: "労働力レジリエンス",
    workforceDesc: "スキルと雇用支援",
    economicRecovery: "経済回復",
    economicDesc: "起業家精神と経済成長",
    totalBeneficiaries: "1000+のJCIプロジェクトを通じてリーチした総受益者",
    membershipDistributionTitle: "地域別会員分布",
    fiiScore: "FIIスコア",
    members: "会員",
    localOrgs: "ローカル組織",
    projectShare: "プロジェクトシェア",
    fastest: "最速",
    emerging: "新興",
    stable: "安定",
    consolidating: "統合中",
    fastestGrowing: "最速成長",
    emergingPotential: "新興ポテンシャル",
    sourceNote: "出典：JCIインパクトレポート2025 - 公式地域データ"
  },
  regionalFIIAnalysis: {
    title: "地域FII分析",
    regionalComparison: "地域FII比較",
    fiiScore: "FIIスコア",
    gapBestWorst: "最良と最悪の差",
    gapIndicates: "このギャップは若者の機会におけるグローバルな不平等を示しています",
    bestPerforming: "最高パフォーマンス",
    mixedPerformance: "混合パフォーマンス",
    equityFocusNeeded: "公平性フォーカスが必要",
    highestOpportunity: "最高の機会",
    countriesWithData: "データのある国",
    mentalHealth: "メンタルヘルス",
    workforce: "労働力",
    entrepreneurship: "起業家精神",
    strengths: "強み",
    challenges: "課題",
    recommendations: "推奨事項",
    jciOpportunity: "JCIの機会",
    members: "会員",
    localOrgs: "ローカル組織"
  },
  regionalFII: {
    title: "地域FII比較",
    fiiScore: "FIIスコア",
    gapIndicator: "最良と最悪の差",
    points: "ポイント",
    gapDescription: "このギャップは若者の機会におけるグローバルな不平等を示しています",
    mentalHealth: "メンタルヘルス",
    workforce: "労働力",
    entrepreneurship: "起業家精神",
    countriesWithData: "データのある国",
    strengths: "強み",
    challenges: "課題",
    recommendations: "推奨事項",
    jciOpportunity: "JCIの機会",
    members: "会員",
    localOrgs: "ローカル組織",
    regions: {
      europe: "ヨーロッパ",
      asiaPacific: "アジアと太平洋",
      americas: "アメリカ",
      africaMe: "アフリカ・中東"
    },
    status: {
      bestPerforming: "最高パフォーマンス",
      mixedPerformance: "混合パフォーマンス",
      equityFocus: "公平性フォーカスが必要",
      highestOpportunity: "最高の機会"
    },
    europe: {
      strength1: "メンタルヘルスサービスアクセス：77/100",
      strength2: "労働力の質：76/100",
      strength3: "自殺予防：73/100",
      strength4: "ポリシーサポート：ユニバーサルヘルスケア統合",
      challenge1: "スティグマ削減が必要",
      challenge2: "若者失業のポケット",
      challenge3: "起業支援がより強化できる",
      recommendation1: "デジタルメンタルヘルスアクセスを拡大",
      recommendation2: "早期介入を増加",
      recommendation3: "女性起業家を支援",
      insight: "ヨーロッパがリード → 他地域のモデル",
      expansion: "50以上の組織への拡大を検討"
    },
    asiaPacific: {
      strength1: "経済成長：強力なビジネス環境",
      strength2: "起業家精神：最高の初期段階率",
      strength3: "テクノロジー採用：最速のデジタル変革",
      strength4: "ユニコーンエコシステム",
      challenge1: "高い格差：40ポイントギャップ",
      challenge2: "メンタルヘルスアクセス：30-50%のみ",
      challenge3: "スキルギャップ",
      challenge4: "失業のポケット",
      recommendation1: "メンタルヘルスを優先",
      recommendation2: "JCIトレーニングでスキルギャップを埋める",
      recommendation3: "RISEプロジェクトをスケール",
      insight: "グローバルJCIの70% = 強力なプレゼンス",
      expansion: "東南アジアはサービス不足"
    },
    americas: {
      strength1: "起業家精神：24-28%の初期段階率",
      strength2: "教育：45%以上の高等教育入学率",
      strength3: "北米：強力なMHインフラ",
      challenge1: "南北ギャップ：34ポイント",
      challenge2: "ラテンアメリカ：MHアクセス20-40%",
      challenge3: "経済的不平等",
      challenge4: "ジェンダーギャップ",
      recommendation1: "ラテンアメリカRISE拡大に焦点",
      recommendation2: "女性起業家支援を構築",
      recommendation3: "デジタルスキルトレーニングを拡大",
      insight: "グローバルJCIの8%だが世界の15% = 成長ポテンシャル",
      expansion: "90のRISEプロジェクトから150以上にスケール"
    },
    africaMe: {
      strength1: "若者人口：最も若い地域（平均29歳）",
      strength2: "起業家精神の願望：52%の若者がビジネスを始めたい",
      strength3: "成長ポテンシャル：年間10-20%のGDP成長（一部地域）",
      strength4: "デジタルリープフロッギング：モバイルファースト採用",
      challenge1: "メンタルヘルスアクセス：10-30%のみ（EUは70%）",
      challenge2: "ヘルスケアインフラ：深刻な不足",
      challenge3: "若者失業：14-16%（グローバル13%）",
      challenge4: "1.7兆ドルの資金ギャップ、30%はアフリカ/中東",
      challenge5: "30%のみがトレーニング済み",
      challenge6: "より多くのトレーニングが必要",
      recommendation1: "ピアサポートメンタルヘルスモデル（非臨床）を実装",
      recommendation2: "JCI経由でSTEM + デジタルスキルトレーニングをスケール",
      recommendation3: "若者起業のためのマイクロファイナンス + メンターシップを拡大",
      recommendation4: "ジェンダーエンパワーメントプログラムに焦点",
      insight: "FIIギャップ：ヨーロッパと22ポイント = 対処可能。重要な拡大地域",
      expansion: "JCI RISEプロジェクトを3倍にスケール"
    }
  },
  regionalMap: {
    title: "地域会員分布",
    subtitle: "地域をクリックして詳細を探索",
    resetView: "ビューをリセット",
    members: "会員",
    localOrgs: "ローカル組織",
    growth: "成長",
    regions: {
      asiaPacific: "アジアと太平洋",
      europe: "ヨーロッパ",
      africaMe: "アフリカ・中東",
      americas: "アメリカ"
    },
    growthStatus: {
      fastest: "最速成長中",
      stable: "安定",
      emerging: "新興ポテンシャル",
      consolidating: "統合中"
    }
  }
} as const;

